<template>
  <el-tabs
    v-model="activeTab"
    :stretch="true"
    class="map-tabs"
    style="height: 100%"
    @tab-change="onTabChange"
  >
    <el-tab-pane :label="$t('DisplayedMap.title')" name="displayed">
      <div style="height: 100%; overflow-x: hidden; overflow-y: auto">
        <displayed-map />
      </div>
    </el-tab-pane>
    <el-tab-pane :label="$t('AddMap.title')" name="add_map">
      <add-map />
    </el-tab-pane>
    <el-tab-pane :label="$t('ImportMapItem.import')" name="import">
      <import-map />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import AddMap from '@/components/maps/AddMap';
import ImportMap from '@/components/maps/ImportMap';
import DisplayedMap from '@/components/maps/DisplayedMap';

import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';

const { track } = useTrack();

export default {
  components: {
    AddMap,
    ImportMap,
    DisplayedMap,
  },
  data() {
    return {
      activeTab: 'add_map',
    };
  },
  methods: {
    onTabChange(name) {
      switch (name) {
        case 'displayed':
          track(
            FunctionIdEnum.globalLayer_layers_showDisplayedLayers,
            EventTypeEnum.CLICK,
          );
          break;
        case 'add_map':
          track(
            FunctionIdEnum.globalLayer_layers_showAllLayers,
            EventTypeEnum.CLICK,
          );
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-tabs {
  display: flex;
  flex-direction: column;
  ::v-deep .el-tabs__header {
    flex: 0 1 auto;
  }
  ::v-deep .el-tabs__item {
    font-weight: normal;
  }
  ::v-deep .el-tabs__nav {
    background: var(--el-border-color-lighter);
  }
  ::v-deep .el-tabs__content {
    // padding: 0 15px;
    flex: 1 1 auto;
  }
  ::v-deep .el-tab-pane {
    height: 100%;
  }
}
</style>

<style>
#pane-import {
  overflow-y: auto;
}
</style>